// FMCG Categories with sales weights
export const categories = [
    {
        id: 'CAT-RAW',
        name: 'Chicken',
        shortName: 'Chicken',
        color: '#E53935',
        salesWeight: 0.35, // 35% of total sales
        avgPrice: 280,
        icon: '🍗',
    },
    {
        id: 'CAT-RTC-NV',
        name: 'Ready to Cook Non-Veg',
        shortName: 'RTC NV',
        color: '#FB8C00',
        salesWeight: 0.20,
        avgPrice: 350,
        icon: '🍖',
    },
    {
        id: 'CAT-RTC-V',
        name: 'Ready to Cook Veg',
        shortName: 'RTC Veg',
        color: '#43A047',
        salesWeight: 0.12,
        avgPrice: 180,
        icon: '🥘',
    },
    {
        id: 'CAT-MUTTON',
        name: 'Mutton',
        shortName: 'Mutton',
        color: '#6D4C41',
        salesWeight: 0.08,
        avgPrice: 600,
        icon: '🥩',
    },
    {
        id: 'CAT-EGG',
        name: 'Eggs',
        shortName: 'Eggs',
        color: '#FDD835',
        salesWeight: 0.10,
        avgPrice: 90,
        icon: '🥚',
    },
    {
        id: 'CAT-OIL',
        name: 'Oil',
        shortName: 'Oil',
        color: '#FFB300',
        salesWeight: 0.08,
        avgPrice: 220,
        icon: '🫒',
    },
    {
        id: 'CAT-MSL',
        name: 'Masala',
        shortName: 'Masala',
        color: '#8E24AA',
        salesWeight: 0.07,
        avgPrice: 65,
        icon: '🌶️',
    },
    {
        id: 'CAT-OTH',
        name: 'Others',
        shortName: 'Others',
        color: '#607D8B',
        salesWeight: 0.08,
        avgPrice: 150,
        icon: '📦',
    },
];

// Helper functions
export function getCategoryById(categoryId) {
    return categories.find(cat => cat.id === categoryId);
}

export function getCategoryName(categoryId) {
    const cat = getCategoryById(categoryId);
    return cat ? cat.name : 'Unknown';
}

export function getCategoryColor(categoryId) {
    const cat = getCategoryById(categoryId);
    return cat ? cat.color : '#9E9E9E';
}

// Get random category weighted by sales
export function getWeightedRandomCategory() {
    const random = Math.random();
    let cumulative = 0;

    for (const cat of categories) {
        cumulative += cat.salesWeight;
        if (random <= cumulative) {
            return cat;
        }
    }
    return categories[0];
}

export default categories;
